import { render, staticRenderFns } from "./ButtonPlayer.vue?vue&type=template&id=fe0fa4b6&scoped=true&"
import script from "./ButtonPlayer.vue?vue&type=script&lang=js&"
export * from "./ButtonPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPlayer.vue?vue&type=style&index=0&id=fe0fa4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0fa4b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VSlideXTransition})
